"use client"

import { useEffect, useState } from "react"
import { jobOpenings } from "@/content/careers"
import { Link, useT } from "@/lib/router"
import { Container, Icon } from "@/components/ui"

const NOTICE_KEY = "orkest-careers-dismissed"
const openingIds = jobOpenings.map((job) => job.id).sort()

export function CareersNotice() {
  const t = useT()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!openingIds.length) return
    try {
      const dismissed: unknown = JSON.parse(window.localStorage.getItem(NOTICE_KEY) ?? "[]")
      setVisible(!Array.isArray(dismissed) || openingIds.some((id) => !dismissed.includes(id)))
    } catch {
      setVisible(true)
    }
  }, [])

  if (!visible) return null
  return (
    <div role="status" className="border-b border-line bg-ice">
      <Container className="flex items-center justify-between gap-4 py-3">
        <Link to="/careers" className="flex min-h-11 items-center gap-3 text-base font-medium text-blue underline underline-offset-4">
          <Icon name="user" className="size-5 shrink-0" />
          {t({ en: "We're hiring. Explore new opportunities at Orkest.", ar: "لدينا فرص عمل جديدة. تعرّف على الوظائف المتاحة في أوركست." })}
        </Link>
        <button
          type="button"
          aria-label={t({ en: "Dismiss careers notice", ar: "إغلاق تنبيه الوظائف" })}
          className="inline-flex size-11 shrink-0 items-center justify-center rounded-r8 text-blue hover:bg-white"
          onClick={() => {
            setVisible(false)
            try { window.localStorage.setItem(NOTICE_KEY, JSON.stringify(openingIds)) } catch { /* Storage is optional. */ }
          }}
        >
          <Icon name="close" className="size-5" />
        </button>
      </Container>
    </div>
  )
}
